import { Component, OnInit } from '@angular/core';

@Component({
  selector: '[sa-left-panel]',
  templateUrl: './left-panel.component.html',
  styleUrls: ['./left-panel.component.scss']
})
export class LeftPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
